var render = function render(){var _vm=this,_c=_vm._self._c;return _c('aside',{staticClass:"the-sidebar"},[_c('base-action-button',{attrs:{"text":"Удалить все категории"},on:{"onButtonClicked":_vm.onDeleteCategories}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }